(function(){

  console.log("Champion gallery script loaded");

  function initChampGallery(root){

    const galleries = root.querySelectorAll(".champ-hero-section");

    galleries.forEach((gallery) => {

      const mainImage = gallery.querySelector("#champMainImage");
      const thumbnails = gallery.querySelectorAll(".champ-thumbnail");

      const prevBtn = gallery.querySelector(".champ-gallery-prev");
      const nextBtn = gallery.querySelector(".champ-gallery-next");

      if(!mainImage || !thumbnails.length) return;

      let currentIndex = 0;

      /* ----------------------------------
      Update Image
      ---------------------------------- */

      function updateImage(index){

        const thumb = thumbnails[index];

        if(!thumb) return;

        const newSrc = thumb.dataset.image;

        if(!newSrc) return;

        mainImage.src = newSrc;
        mainImage.srcset = newSrc;

        thumbnails.forEach(t => t.classList.remove("active"));

        thumb.classList.add("active");

        currentIndex = index;

      }

      /* ----------------------------------
      Thumbnail click
      ---------------------------------- */

      thumbnails.forEach((thumb, i) => {

        thumb.addEventListener("click", () => {

          updateImage(i);

        });

      });

      /* ----------------------------------
      Next / Prev Buttons
      ---------------------------------- */

      if(nextBtn){

        nextBtn.addEventListener("click", () => {

          let next = currentIndex + 1;

          if(next >= thumbnails.length) next = 0;

          updateImage(next);

        });

      }

      if(prevBtn){

        prevBtn.addEventListener("click", () => {

          let prev = currentIndex - 1;

          if(prev < 0) prev = thumbnails.length - 1;

          updateImage(prev);

        });

      }

      /* ----------------------------------
      Swipe Support
      ---------------------------------- */

      let startX = 0;
      let endX = 0;

      const wrapper = gallery.querySelector(".champ-main-image-wrapper");

      if(wrapper){

        wrapper.addEventListener("touchstart",(e)=>{

          startX = e.touches[0].clientX;

        });

        wrapper.addEventListener("touchend",(e)=>{

          endX = e.changedTouches[0].clientX;

          handleSwipe();

        });

      }

      function handleSwipe(){

        const diff = startX - endX;

        if(Math.abs(diff) < 40) return;

        if(diff > 0){

          /* swipe left */

          let next = currentIndex + 1;
          if(next >= thumbnails.length) next = 0;
          updateImage(next);

        }else{

          /* swipe right */

          let prev = currentIndex - 1;
          if(prev < 0) prev = thumbnails.length - 1;
          updateImage(prev);

        }

      }

    });

  }

  /* Page load */

  document.addEventListener("DOMContentLoaded", () => {

    initChampGallery(document);

  });

  /* Shopify section reload */

  document.addEventListener("shopify:section:load", (event) => {

    initChampGallery(event.target);

  });

})();

(function(){

  function initSlider(root){

    const galleries = root.querySelectorAll(".champ-gallery");

    galleries.forEach((gallery)=>{

      const slider = gallery.querySelector(".champ-slider");
      const slides = gallery.querySelectorAll(".champ-slide");
      const thumbs = gallery.querySelectorAll(".champ-thumbnail");

      const next = gallery.querySelector(".champ-gallery-next");
      const prev = gallery.querySelector(".champ-gallery-prev");

      let index = 0;

      function goTo(i){

        index = i;

        slider.scrollTo({
          left: slides[i].offsetLeft,
          behavior:"smooth"
        });

        thumbs.forEach(t=>t.classList.remove("active"));

        if(thumbs[i]) thumbs[i].classList.add("active");

      }

      thumbs.forEach((thumb,i)=>{

        thumb.addEventListener("click",()=>{

          goTo(i);

        });

      });

      next?.addEventListener("click",()=>{

        index++;

        if(index >= slides.length) index = 0;

        goTo(index);

      });

      prev?.addEventListener("click",()=>{

        index--;

        if(index < 0) index = slides.length - 1;

        goTo(index);

      });

    });

  }

  document.addEventListener("DOMContentLoaded",()=>{

    initSlider(document);

  });

  document.addEventListener("shopify:section:load",(e)=>{

    initSlider(e.target);

  });

})();
// section 2
document.addEventListener("click", function(e){

  const trigger = e.target.closest(".champ-play");

  if(!trigger) return;

  const container = trigger.closest(".champ-video-thumb");

  const videoFile = trigger.dataset.videoFile;
  const videoUrl = trigger.dataset.videoUrl;

  /* pause any existing videos */

  if (window.stopAllVideos) window.stopAllVideos();

  document.querySelectorAll(".champ-video-thumb video").forEach(v => {
    v.pause();
  });

  let player;

  if(videoFile){

    player = `
      <video
        class="champ-testimonial-video"
        autoplay
        playsinline
        
      >
        <source src="${videoFile}" type="video/mp4">
      </video>
    `;

  }

  else if(videoUrl){

    if(videoUrl.includes("youtube")){

      const id = videoUrl.split("v=")[1]?.split("&")[0];

      player = `
        <iframe
          src="https://www.youtube.com/embed/${id}?autoplay=1&enablejsapi=1&cc_load_policy=0&modestbranding=1&rel=0"
          allow="autoplay; encrypted-media"
          allowfullscreen
          loading="lazy"
          frameborder="0"
        ></iframe>
      `;

    }

  }

  if(player){

    container.innerHTML = player;

    const video = container.querySelector("video");

    if(video){

      video.addEventListener("click", function(){

        if(video.paused){
          video.play();
        }else{
          video.pause();
        }

      });

    }

  }

});

/* Carousel arrows — delegated on document instead of bound per-element at
   parse time. The theme's client-side page-content refresh (view transitions)
   can replace the carousel node after this script's initial defer execution,
   which silently orphaned closures holding the old node (arrows visually
   present, clicks did nothing). Delegation re-queries the live DOM on every
   click/scroll, so it can't go stale. */

const CHAMP_CAROUSEL_SCROLL_AMOUNT = 260;

function champUpdateCarouselArrows(wrapper){

  const carousel = wrapper.querySelector(".champ-carousel");
  const prev = wrapper.querySelector(".champ-carousel-prev");
  const next = wrapper.querySelector(".champ-carousel-next");

  if(!carousel) return;

  const scrollLeft = carousel.scrollLeft;
  const maxScroll = carousel.scrollWidth - carousel.clientWidth;

  if(prev){
    prev.style.opacity = scrollLeft <= 5 ? "0" : "1";
    prev.style.pointerEvents = scrollLeft <= 5 ? "none" : "auto";
  }

  if(next){
    next.style.opacity = scrollLeft >= maxScroll - 5 ? "0" : "1";
    next.style.pointerEvents = scrollLeft >= maxScroll - 5 ? "none" : "auto";
  }

}

document.addEventListener("click", function(e){

  const btn = e.target.closest(".champ-carousel-prev, .champ-carousel-next");

  if(!btn) return;

  const wrapper = btn.closest(".champ-carousel-wrapper");
  const carousel = wrapper && wrapper.querySelector(".champ-carousel");

  if(!carousel) return;

  const direction = btn.classList.contains("champ-carousel-next") ? 1 : -1;

  carousel.scrollBy({
    left: direction * CHAMP_CAROUSEL_SCROLL_AMOUNT,
    behavior: "smooth"
  });

});

document.addEventListener("scroll", function(e){

  const carousel = e.target;

  if(!carousel.classList || !carousel.classList.contains("champ-carousel")) return;

  const wrapper = carousel.closest(".champ-carousel-wrapper");

  if(wrapper) champUpdateCarouselArrows(wrapper);

}, true);

function champInitCarouselArrows(root){

  root.querySelectorAll(".champ-carousel-wrapper").forEach(champUpdateCarouselArrows);

}

document.addEventListener("DOMContentLoaded", () => champInitCarouselArrows(document));
window.addEventListener("load", () => champInitCarouselArrows(document));
document.addEventListener("shopify:section:load", (event) => champInitCarouselArrows(event.target));

document.addEventListener("click", function(e){

  const trigger = e.target.closest(".accordion-trigger");

  if(!trigger) return;

  const item = trigger.closest(".accordion-item");
  const content = item.querySelector(".accordion-content");

  const openItem = document.querySelector(".accordion-item.active");

  /* close previously opened */

  if(openItem && openItem !== item){

    openItem.classList.remove("active");
    openItem.querySelector(".accordion-trigger").classList.remove("active");
    openItem.querySelector(".accordion-content").classList.remove("active");

  }

  /* toggle current */

  item.classList.toggle("active");
  trigger.classList.toggle("active");
  content.classList.toggle("active");

});

document.querySelectorAll('product-recommendations').forEach((section) => {

  const url = section.dataset.url;

  fetch(url)
    .then((response) => response.text())
    .then((text) => {

      const html = document.createElement('div');
      html.innerHTML = text;

      const recommendations = html.querySelector('product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        section.innerHTML = recommendations.innerHTML;
      }

    })
    .catch((e) => {
      console.error('Product recommendations failed:', e);
    });

});

/* ================================
STICKY CART
================================ */

document.addEventListener("click",function(e){

  const qtyBtn = e.target.closest("[data-qty]");

  if(qtyBtn){

    const valueEl = document.querySelector(".champ-qty-value");
    let qty = parseInt(valueEl.textContent);

    if(qtyBtn.dataset.qty === "plus") qty++;
    if(qtyBtn.dataset.qty === "minus" && qty > 1) qty--;

    valueEl.textContent = qty;
  }

});


document.addEventListener("click",function(e){

  const btn = e.target.closest(".champ-sticky-atc");

  if(!btn) return;

  const variantId = btn.dataset.variantId;
  const qty = parseInt(document.querySelector(".champ-qty-value").textContent);

  fetch("/cart/add.js",{
    method:"POST",
    headers:{
      "Content-Type":"application/json"
    },
    body:JSON.stringify({
      id:variantId,
      quantity:qty
    })
  })
  .then(res => res.json())
  .then(() => {

    document.dispatchEvent(new CustomEvent("cart:refresh"));

  });

});